import { buildLevelsCollection } from "../collections/levels";
import { buildQuestionsCollection } from "../collections/questions";
import { buildStoriesCollection } from "../collections/stories";
import { buildUnitCollection } from "../collections/units";
import type { LearningPathContentCollections } from "../contentImport/learningPath";

export function buildLearningPathContentCollections(
  accountId: string,
  spaceId: string
): LearningPathContentCollections {
  const id = { accountId, spaceId };
  return {
    units: buildUnitCollection(id),
    stories: buildStoriesCollection(id),
    questions: buildQuestionsCollection(id),
    levels: buildLevelsCollection(id),
  };
}
